import { Address } from '@dreryk/address-common-api';
import { FirstName, LastName } from '@dreryk/person-name-common-api';

import { BindingCreator } from '@dreryk/react-common';

import {
   GuardianEnteredByUserFormBeanPart,
   GuardianFieldName,
   GuardianFormBeanPart,
   GuardianWithAddressFormBeanPart,
   ReferralToPsychiatricHospitalFormGuardianAddress,
} from './guardianSection.types';
import { ReferralToPsychiatricHospitalFormGuardianSelectBean } from './GuardianSelect/guardianSelect.types';

export const getReferralToPsychiatricHospitalFormGuardianAddress = (
   guardian: {
      address?: Address;
   } | null
): ReferralToPsychiatricHospitalFormGuardianAddress => {
   return {
      street: guardian?.address?.findStreet()?.asString() ?? null,
      building: guardian?.address?.findBuilding()?.asString() ?? null,
      flat: guardian?.address?.findFlat()?.asString() ?? null,
      country: guardian?.address?.getCountry() ?? null,
      postcode: guardian?.address?.findPostcode() ?? null,
      town: guardian?.address?.findTown()?.getName() ?? null,
   };
};

type Guardian = {
   firstName?: FirstName;
   lastName?: LastName;
   address?: Address;
   enteredByUser?: boolean;
   id?: number;
};

export const mapGuardianToReferralToPsychiatricHospitalFormGuardian = (
   guardian: Guardian
): ReferralToPsychiatricHospitalFormGuardianSelectBean => {
   if (guardian.enteredByUser) {
      return 'ENTERED_BY_USER';
   }
   return {
      id: guardian.id,
      firstName: guardian.firstName?.asString(),
      lastName: guardian.lastName?.asString(),
      address: guardian.address,
   };
};

export const isGuardianAddressSectionVisible = <FIELD_NAME extends GuardianFieldName>(
   currentValue: ReferralToPsychiatricHospitalFormGuardianSelectBean | null,
   currentGuardianNotApplicable: boolean,
   register: BindingCreator<GuardianFormBeanPart, FIELD_NAME>
): register is BindingCreator<GuardianWithAddressFormBeanPart> =>
   currentValue !== null && !currentGuardianNotApplicable;

export const isGuardianNameSectionVisible = <FIELD_NAME extends GuardianFieldName>(
   currentValue: ReferralToPsychiatricHospitalFormGuardianSelectBean | null,
   currentGuardianNotApplicable: boolean,
   register: BindingCreator<GuardianFormBeanPart, FIELD_NAME>
): register is BindingCreator<GuardianEnteredByUserFormBeanPart> =>
   currentValue === 'ENTERED_BY_USER' && !currentGuardianNotApplicable;
